var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-number-component"},[_c('label',{staticClass:"input-label-number"},[_vm._v(_vm._s(_vm.label))]),_c('input',{staticClass:"input-number",attrs:{"id":_vm.id,"type":"number","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit("input", $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }